import { takeLeading } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './investmentsNewsfeedActions';
import { getLastSyncDate } from './investmentsNewsfeedSelectors';
import { mkInvestmentsNewsfeed } from './investmentsNewsfeedTypes';

export function* getInvestmentsNewsfeedActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'investments newsfeed',
    resourceBaseUrl: '/v2/investments/newsfeed',
    getLastSyncDate,
    successAction: actions.getInvestmentsNewsfeedSuccess,
    failureAction: actions.getInvestmentsNewsfeedFailure,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentsNewsfeed(data)),
  });
  yield takeLeading(actions.getInvestmentsNewsfeed, resourceSagaUtils.qcsSyncGetResources, config);
}

export default [getInvestmentsNewsfeedActionWatcher];
